// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1CwZj","rootCenter":"LoadMoreObserver_rootCenter__lXKjF","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3mFZG"};